import React, { useState, useEffect } from 'react';
import ScrollReveal from 'scrollreveal';
import styles from './Services.module.css';

import residentialImg from '../../images/מורן וינברגר פרוייקטים 5.webp';
import commercialImg from '../../images/מורן וינברגר פרוייקטים 9.webp';
import projectMgmtImg from '../../images/מורן וינברגר פרוייקטים 6.webp';
import kitchenImg from '../../images/מורן וינברגר פרוייקטים 8.webp';
import logoImg from '../../images/מורן וינברגר לוגו.webp';

const services = [
  {
    id: 1,
    number: '01',
    title: 'עיצוב פנים למגורים',
    shortTitle: 'עיצוב למגורים',
    subtitle: 'תכנון מקיף מאפיון צרכים ועד הדמיה מלאה וליווי עד המפתח ביד',
    image: residentialImg,
    quote: 'לכל פונקציה יתוכנן מקום משלה - הבית ישרת אתכם ולא אתם אותו',
    suitableFor: [
      'קניתם דירה חדשה ואין לכם מושג מאיפה להתחיל',
      'הילדים גדלו, הצרכים השתנו, והבית כבר לא עובד לכם',
      'עוברים שיפוץ ורוצים שמישהי תוביל את העיצוב מההתחלה ועד הסוף',
      'רוצים בית שבאמת מותאם לאורח החיים שלכם - לא סתם יפה, גם פרקטי',
    ],
    includes: [
      'אפיון צרכים מעמיק ואישי',
      'תכנון מלא של כל חלל בבית',
      'סקיצות תכנוניות וקונספט עיצובי',
      'בחירת צבעים, חומרים וריהוט',
      'הדמיה תלת-ממדית מלאה לפני ביצוע',
      'ליווי מלא עד המפתח ביד',
    ],
    steps: [
      {
        title: 'פגישת היכרות ואפיון צרכים',
        description: 'קניתם דירה? משפצים? לא יודעים מאיפה להתחיל? נתחיל בפגישת היכרות שמטרתה להכיר אתכם - להבין מה חשוב לכם, מה ההרגלים והצרכים שלכם, מה מפריע לכם היום בבית הנוכחי ואיך אתם מדמיינים את החיים בבית החדש.'
      },
      {
        title: 'תכנון מלא של כל חלל בבית',
        description: 'אקח את רשימת הצרכים והחלומות שלכם ואטמיע אותם לתוך תכנון ועיצוב הבית. אכין מספר סקיצות עד שנקלע למטרה והתכנון יענה על כל הדרישות. אדאג לא להשאיר אף סנטימטר לא מנוצל בבית.'
      },
      {
        title: 'בחירת צבעים, חומרים וריהוט',
        description: 'נצא יחד לימי בחירות משותפים - ריצופים, חיפויים, סניטריה, ריהוט, תאורה, גווני קירות, וילונות ואקססוריס. כל בחירה תהיה בהתאם לאופי שלכם ולחזון העיצובי שבנינו יחד.'
      },
      {
        title: 'הדמיה תלת-ממדית מלאה',
        description: 'תקבלו הדמיה מלאה של הבית לפני שמתחילים - רואים בדיוק איך הכל ייראה, מרגישים את האווירה, ומשנים מה שצריך. הכל עוד על המסך, לפני שקבלן אחד נכנס לאתר.'
      },
      {
        title: 'ליווי מלא עד המפתח ביד',
        description: 'שלב אחר שלב נהפוך את הבית מאוסף של קירות לבית מלא באופי. אלווה אתכם לאורך כל הדרך - מהתכנון הראשוני ועד הרגע שתיכנסו לבית המוכן שלכם.'
      }
    ]
  },
  {
    id: 2,
    number: '02',
    title: 'עיצוב מסחרי',
    shortTitle: 'עיצוב מסחרי',
    subtitle: 'תכנון חללים מסחריים כולל רישוי, תקנים, הנדסת אנוש והעלאת ערך הנכס',
    image: commercialImg,
    quote: 'עיצוב נכון לא רק משדרג את המקום - הוא גורם לעסק להצליח מכל הבחינות',
    suitableFor: [
      'פותחים עסק חדש וצריכים שהמקום ייראה טוב וגם יעבוד כמו שצריך',
      'משפצים משרד ורוצים חלל שמעודד את העובדים להגיע כל בוקר',
      'מקימים מסעדה ולא יודעים מאיפה מתחילים עם כל התקנים והרישוי',
      'רוצים להעלות את ערך הנכס המסחרי שלכם דרך עיצוב נכון',
    ],
    includes: [
      'תכנון חלל מותאם לאופי העסק והקהל',
      'הנדסת אנוש ותפקוד מיטבי של החלל',
      'טיפול מלא ברישוי, תקנים וכשרויות',
      'תיאום כל היועצים - אינסטלציה, חשמל ובנוי',
      'הדמיה תלת-ממדית לפני ביצוע',
      'העלאת ערך הנכס',
    ],
    steps: [
      {
        title: 'תכנון חלל מותאם לעסק ולקהל',
        description: 'פתחתם עסק? משפצים את המשרד? מקימים מסעדה? אני לא באה רק כדי שהמקום ייראה יפה - אני באה לגרום לו להצליח. תכנון חלל מסחרי דורש הבנה עמוקה של אופי העסק, קהל היעד וזרימת התנועה במקום.'
      },
      {
        title: 'טיפול מלא ברישוי, תקנים וכשרויות',
        description: 'חלל מסחרי דורש עמידה בתקנים ורישוי - ואני מטפלת בכל זה. מהנדסת אנוש ועד אישורי כשרות, כל הבירוקרטיה מנוהלת עבורכם כדי שתוכלו להתמקד בעסק.'
      },
      {
        title: 'הנדסת אנוש ותפקוד מיטבי',
        description: 'תכנון שמתחשב באנשים שישתמשו בחלל - עובדים, לקוחות ואורחים. כל פרט מתוכנן לתפקוד מיטבי, מהאקוסטיקה ועד פריסת הריהוט.'
      },
      {
        title: 'תיאום כל היועצים והספקים',
        description: 'אינסטלציה, חשמל, בנוי, יועצים - אני מרכזת את כל בעלי המקצוע ומוודאת שכולם עובדים בסנכרון מושלם. אתם לא צריכים לרדוף אחרי אף אחד.'
      },
      {
        title: 'העלאת ערך הנכס',
        description: 'עיצוב נכון של חלל מסחרי לא רק משפר את חוויית הלקוחות - הוא גם מעלה משמעותית את ערך הנכס ועוזר למכור או להשכיר אותו ביוקר יותר.'
      }
    ]
  },
  {
    id: 3,
    number: '03',
    title: 'ניהול פרויקטים',
    shortTitle: 'ניהול פרויקטים',
    subtitle: 'ניהול מלא של הפרויקט - תקציב, לוחות זמנים, ספקים ופיקוח בשטח',
    image: projectMgmtImg,
    quote: 'אני דוגלת בשקיפות ואמינות - תדעו בדיוק מה קורה בכל שלב של הפרויקט',
    suitableFor: [
      'נתקעתם באמצע שיפוץ ומרגישים שהכל מתפרק',
      'עוד לפני שמתחילים ורוצים שמישהי פשוט תיקח את כל הניהול על עצמה',
      'התקציב מתנפח ואתם צריכים מישהי שיודעת לנהל משא ומתן ולשמור על כל שקל',
      'רוצים להמשיך עם החיים הרגילים בזמן שהפרויקט רץ - בלי לרדוף אחרי אף אחד',
    ],
    includes: [
      'ניהול לוחות זמנים מדויקים',
      'בקרת תקציב שוטפת ושקופה',
      'ריכוז כל בעלי המקצוע והיועצים',
      'משא ומתן מול ספקים והשוואת הצעות מחיר',
      'פיקוח צמוד על ביצוע וטיב העבודה',
      'שקיפות ואמינות לאורך כל הדרך',
    ],
    steps: [
      {
        title: 'ניהול לוחות זמנים מדויקים',
        description: 'כל ספק יודע מתי נכנס ומתי יוצא. אני דואגת שכל דבר קורה בדיוק מתי שהוא צריך לקרות - מתאמת בעלי מקצוע, עוקבת אחרי התקדמות ומוודאת שאף אחד לא מאחר.'
      },
      {
        title: 'בקרת תקציב שוטפת ושקופה',
        description: 'עוד לפני שמתחילים, אני יושבת איתכם על כל סעיף. תדעו מראש בדיוק כמה זה עולה ומה קורה בכל תרחיש. משא ומתן מול ספקים, השוואת הצעות מחיר ובקרה צמודה על כל הוצאה.'
      },
      {
        title: 'ריכוז כל בעלי המקצוע והיועצים',
        description: 'אינסטלציה, חשמל, יועצים, בנוי - מי שיודעת לעשות את כל השילובים בהכרח תביא להצלחת הפרויקט. אני מרכזת הכל כדי שלא תצטרכו לרדוף אחרי אף אחד.'
      },
      {
        title: 'פיקוח על ביצוע וטיב העבודה',
        description: 'אני בשטח, בודקת כל פרט, מוודאת שהעבודה מתבצעת לפי התכניות ולפי הסטנדרט הגבוה ביותר. שקע לא במקום? ארון שלא נפתח? את הטעויות האלה מונעים מראש.'
      }
    ]
  },
  {
    id: 4,
    number: '04',
    title: 'תכנון מטבחים',
    shortTitle: 'תכנון מטבחים',
    subtitle: 'תכנון המטבח מאפס, ניהול משא ומתן מול ספקים וחיסכון משמעותי בעלויות',
    image: kitchenImg,
    quote: 'לפני שרצים לחברת מטבחים - דברו איתי. תקבלו תוצאה מדויקת במחיר נמוך יותר',
    suitableFor: [
      'לפני שרצים לחברת מטבחים ורוצים לדעת מה באמת אפשר לעשות',
      'רוצים מטבח שמתוכנן בדיוק לפי ההרגלים שלכם ולא לפי קטלוג',
      'שמעתם שאפשר לחסוך המון כסף עם תכנון עצמאי - וזה נכון',
      'רוצים שמישהי מקצועית תנהל את המשא ומתן מול חברות המטבחים במקומכם',
    ],
    includes: [
      'תכנון מטבח מלא מאפס',
      'תכנון פנימי מפורט - אחסון, פרזול ודיטלס',
      'בחירת חומרים, ספקים ורהיטים',
      'ניהול משא ומתן מול חברות מטבחים ונגרים',
      'פיקוח על הייצור וההתקנה',
      'חיסכון ממוצע של 30% בעלויות',
    ],
    steps: [
      {
        title: 'תכנון מטבח מלא מאפס',
        description: 'אני מתכננת לכם את המטבח מהיסוד - תכנון פנימי מפורט, חלוקת אחסון חכמה, זרימת עבודה נוחה ותכנון שמתאים בדיוק לצרכים ולהרגלי הבישול שלכם.'
      },
      {
        title: 'בחירת חומרים, ספקים ורהיטים',
        description: 'נבחר יחד את החומרים - משטחי עבודה, חזיתות, ידיות, פרזול. כל פרט ייבחר בקפידה כדי שהמטבח יהיה לא רק יפה אלא גם עמיד ופרקטי לשנים ארוכות.'
      },
      {
        title: 'ניהול משא ומתן מול חברות מטבחים',
        description: 'עם תכניות מפורטות ביד, ניגש לחברות מטבחים ונגרים לקבלת הצעות מחיר. אני מנהלת את המשא ומתן מולם ודואגת שתדעו בדיוק מה אתם מקבלים - ובמחיר הטוב ביותר.'
      },
      {
        title: 'פיקוח על הייצור וההתקנה',
        description: 'אני מלווה את התהליך מהייצור ועד ההתקנה הסופית. בודקת שהכל מיוצר בדיוק לפי התכניות, ושההתקנה מתבצעת כמו שצריך - בלי פשרות.'
      },
      {
        title: 'חיסכון משמעותי בעלויות',
        description: 'חוסכת לכם את כאב הראש ומביאה תוצאה שמדויקת למה שרציתם. הלקוחות שלי חוסכים בממוצע 30% בעלויות המטבח - כי תכנון נכון מראש חוסך טעויות יקרות.'
      }
    ]
  }
];

const ServicesSection = () => {
  const [activeStripe, setActiveStripe] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);

  const handleServiceClick = (service) => {
    setSelectedService(service);
    document.body.style.overflow = 'hidden';
    setTimeout(() => setIsOverlayVisible(true), 50);
  };

  const closeOverlay = () => {
    setIsOverlayVisible(false);
    setTimeout(() => {
      setSelectedService(null);
      document.body.style.overflow = '';
    }, 400);
  };

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') closeOverlay();
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, []);

  useEffect(() => {
    if (window.innerWidth > 1024) return;

    const sr = ScrollReveal({
      distance: '30px',
      duration: 1200,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      reset: false,
      viewFactor: 0.2,
    });

    sr.reveal(`.${styles.serviceStripe}`, {
      origin: 'bottom',
      interval: 200,
      scale: 0.95,
    });

    return () => sr.destroy();
  }, []);

  return (
    <section className={styles.servicesSection} id="שירותים">
      {/* Header */}
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionHeaderTitle}>שירותי הסטודיו</h2>
      </div>

      {/* Main Services Container */}
      <div className={styles.servicesContainer}>
        {services.map((service, index) => {
          const isActive = activeStripe === index;

          return (
            <div
              key={service.id}
              className={`${styles.serviceStripe} ${isActive ? styles.stripeActive : ''}`}
              onMouseEnter={() => setActiveStripe(index)}
              onMouseLeave={() => setActiveStripe(null)}
              onClick={() => handleServiceClick(service)}
            >
              <img
                src={service.image}
                alt={service.title}
                className={styles.stripeImage}
                loading="lazy"
                decoding="async"
              />
              <div className={styles.stripeOverlay} />
              <div className={styles.stripeNumber}>
                <span>{service.number}</span>
              </div>
              <div className={styles.stripeVerticalText}>
                <span>{service.shortTitle}</span>
              </div>
              <div className={styles.stripeContent}>
                <h3 className={styles.stripeTitle}>{service.title}</h3>
                <p className={styles.stripeSubtitle}>{service.subtitle}</p>
                <button className={styles.stripeButton}>
                  <span>פרטים נוספים</span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M7 17L17 7M17 7H7M17 7V17" />
                  </svg>
                </button>
              </div>
              <div className={styles.stripeAccent} />
            </div>
          );
        })}
      </div>

      {/* Modal - scrollable page */}
      {selectedService && (
        <div
          className={`${styles.modal} ${isOverlayVisible ? styles.modalVisible : ''}`}
          onClick={closeOverlay}
        >
          {/* Close button - outside scrollable content so it always floats */}
          <button className={styles.closeButton} onClick={closeOverlay}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>

          <div
            className={`${styles.modalContent} ${isOverlayVisible ? styles.modalContentVisible : ''}`}
            onClick={e => e.stopPropagation()}
          >

            {/* Body */}
            <div className={styles.modalBody}>
              <h2 className={styles.modalTitle}>{selectedService.title}</h2>
              <p className={styles.modalSubtitle}>{selectedService.subtitle}</p>

              {/* מה כולל השירות */}
              <h3 className={styles.sectionTitle}>מה כולל השירות</h3>
              <ul className={styles.includesList}>
                {selectedService.includes.map((item, i) => (
                  <li key={i} className={styles.includesItem} style={{ animationDelay: `${0.35 + i * 0.06}s` }}>
                    <span className={styles.includesCheck}>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                        <path d="M20 6L9 17l-5-5" />
                      </svg>
                    </span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              {/* למי השירות מתאים */}
              <h3 className={styles.sectionTitle}>השירות מתאים לכם אם אתם...</h3>
              <ul className={styles.suitableList}>
                {selectedService.suitableFor.map((item, i) => (
                  <li key={i} className={styles.suitableItem} style={{ animationDelay: `${0.65 + i * 0.08}s` }}>
                    <span className={styles.suitableDot} />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              {/* שלבי התהליך */}
              <h3 className={styles.sectionTitle}>שלבי התהליך</h3>
              <div className={styles.stepsContainer}>
                {selectedService.steps.map((step, i) => (
                  <div key={i} className={styles.stepCard}>
                    <div className={styles.stepLogo}>
                      <img src={logoImg} alt="" className={styles.stepLogoImg} loading="lazy" decoding="async" />
                    </div>
                    <div className={styles.stepContent}>
                      <h4 className={styles.stepTitle}>{step.title}</h4>
                      <p className={styles.stepDescription}>{step.description}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* CTA - WhatsApp */}
              <a
                href={`https://wa.me/972502177062?text=${encodeURIComponent(`היי מורן, הגעתי מהאתר ואשמח לשמוע עוד על ${selectedService.title}`)}`}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.ctaButton}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
                <span>לחצו כאן ואנחנו מדברים</span>
              </a>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ServicesSection;
